import { render, staticRenderFns } from "./AddCustomAttribute.vue?vue&type=template&id=493dbc7a&scoped=true"
import script from "./AddCustomAttribute.vue?vue&type=script&lang=js"
export * from "./AddCustomAttribute.vue?vue&type=script&lang=js"
import style0 from "./AddCustomAttribute.vue?vue&type=style&index=0&id=493dbc7a&prod&lang=scss"
import style1 from "./AddCustomAttribute.vue?vue&type=style&index=1&id=493dbc7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493dbc7a",
  null
  
)

export default component.exports